import { RolodexEntryTagsType, RolodexEntryType, RolodexFileRef } from 'types'

/**
 * Represents a document file with metadata extracted from a Rolodex entry.
 * Casing isn't camelcase in order to align the keys exactly with those of the GeckoEntry
 */
export interface RolodexDocumentEntry {
  type: RolodexEntryType.REPORT
  entry_id: string
  fields: Readonly<Record<string, unknown>>
  filename?: string
  size?: number
  file_type?: string
  categories: ReadonlyArray<string>
  upload_date?: string
  document_date?: string
  rolodex_file_ref?: RolodexFileRef

  // Fields specifically added for backcompat with reports:
  visible_name?: string
  notes?: string
  tags: RolodexEntryTagsType

  /** Clockwise rotation in degrees (0, 90, 180, 270) per page number (1-indexed string key) */
  pageRotations?: Record<string, number>
}

/**
 * Represents a tag field for document tagging
 */
export interface TaggedDocumentField {
  key: string
  value: string
}

export enum DocumentType {
  PDF = 'PDF',
  EXCEL = 'Excel',
  WORD = 'Word',
  POWERPOINT = 'PowerPoint',
  IMAGE = 'Image',
  TEXT = 'Text',
  CSV = 'CSV',
  OTHER = 'Other',
}
